import React from 'react';
import { motion } from 'framer-motion';
const crew = [{
  name: 'Jimmy Donaldson',
  role: 'Creator & Host',
  image: 'https://cdn.magicpatterns.com/uploads/gPtYQGTcYMGgsnMB9qtNvM/jimmy(1).webp',
  isMain: true
}, {
  name: 'Chandler Hallow',
  role: 'Cast Member',
  image: 'https://cdn.magicpatterns.com/uploads/spfePxSim1VgUjDFK6EfZw/chandler.webp',
  isMain: false
}, {
  name: 'Karl Jacobs',
  role: 'Cast Member',
  image: 'https://cdn.magicpatterns.com/uploads/vZDtakqod3rQXHiBMSacfE/karl.webp',
  isMain: false
}, {
  name: 'Nolan Hansen',
  role: 'Cast Member',
  image: 'https://cdn.magicpatterns.com/uploads/r4T1QkSpTierJCqAXkxmzR/nolan.webp',
  isMain: false
}, {
  name: 'Tareq Salameh',
  role: 'Director',
  image: 'https://cdn.magicpatterns.com/uploads/tE7JnACRQ12iSnmsnjkcna/tareq.webp',
  isMain: false
}];
export function CrewSection() {
  return <section className="w-full py-24 bg-[#0f0f1a] relative overflow-hidden" data-id="element-28">
      {/* Mask Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat opacity-30" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/dCSAB67fkgQRCLoh3yeqbi/mask.webp')"
    }} data-id="element-29" />

      {/* Gradient overlay for better text readability */}
      <div className="absolute inset-0 z-1 bg-gradient-to-b from-[#0f0f1a]/80 via-transparent to-[#0f0f1a]/90 pointer-events-none" data-id="element-30" />

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#ffd700]/30 to-transparent z-10" data-id="element-31" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-33">
          <h2 className="font-oswald text-4xl md:text-6xl font-bold text-white uppercase tracking-wider" data-id="element-34">
            The Beast <span className="text-[#ffd700]" data-id="element-35">Crew</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-end" data-id="element-36">
          {crew.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative group flex flex-col items-center ${member.isMain ? 'col-span-2 md:col-span-3 lg:col-span-1 lg:order-3 lg:-mt-12' : 'lg:order-1'}`} data-id="element-37">
              <div className={`relative rounded-2xl overflow-hidden border-2 border-[#ffd700]/20 group-hover:border-[#ffd700] transition-all duration-500 ${member.isMain ? 'w-full aspect-[3/4] lg:scale-110 z-10 shadow-[0_0_30px_rgba(255,215,0,0.2)]' : 'w-full aspect-[3/4] grayscale group-hover:grayscale-0'}`} data-id="element-38">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-39" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-80" data-id="element-40" />

                <div className="absolute bottom-0 left-0 right-0 p-4 text-center" data-id="element-41">
                  <h3 className="font-oswald text-xl md:text-2xl font-bold text-white uppercase tracking-wide mb-1" data-id="element-42">
                    {member.name}
                  </h3>
                  <p className="text-[#ffd700] text-sm font-bold tracking-widest uppercase" data-id="element-43">
                    {member.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}